module.exports = __webpack_public_path__ + "img/icon_sharing.d7d87191.png";